import institutionAPI from 'services/institutionAPI'

export default async function logout() {
  const response = await institutionAPI({
    url: '/auth/person-auth/logout',
    method: 'DELETE',
  })

  return response
}
